export const EventConstant = {
  GET_EVENT_SUCCESS: 'GET_EVENT_SUCCESS',
  GET_EVENT_FAIL: 'GET_EVENT_FAIL',
  LOADING_FALSE: 'LOADING_FALSE',
  LOADING_TRUE: 'LOADING_TRUE',
};
